// extracted by mini-css-extract-plugin
export default {"container":"MisProductos_container__Sw55z","container_body":"MisProductos_container_body__ZP7Or","emptyState":"MisProductos_emptyState__cerb7"};